var productConfigurator = document.getElementById("configurator");
var action;
var blockId;
var code;
var language = document.documentElement.lang;

if (productConfigurator !== null && productConfigurator !== undefined) {
    action = productConfigurator.getAttribute('data-action');
    blockId = productConfigurator.getAttribute('data-blockid');
    code = productConfigurator.getAttribute('data-productcode');
}

function initProductConfigurator() {
    var select = document.querySelectorAll(".js-select");
    if (select !== null) {
        for (var i = 0; i < select.length; i++) {
            select[i].addEventListener("change", function () {
                selectOptionsDdl();
            });
        }
    }
}

function BindResult(html) {
    var configurator = document.getElementById("configurator");

    configurator.outerHTML = html;

    initCartService();
    initProductConfigurator();
    initKeepMePosted();
}

function selectOptionsDdl() {

    var footCrossDdl = document.getElementById('selectedFootCrossOption');
    var selectedFootCross;

    if (footCrossDdl !== null) {
        // get the index of the selected option 
        var footCrossIdx = footCrossDdl.selectedIndex;
        // get the value of the selected option 
        selectedFootCross = footCrossDdl.options[footCrossIdx].value;
    }

    var colorLegsDdl = document.getElementById('selectedColorLegsOption');
    var selectedColorLegs;

    if (colorLegsDdl !== null) {
        // get the index of the selected option 
        var colorLegsIdx = colorLegsDdl.selectedIndex;
        // get the value of the selected option 
        selectedColorLegs = colorLegsDdl.options[colorLegsIdx].value;
    }

    var paintColorDdl = document.getElementById('selectedPaintColorOption');
    var selectedPaintColor;

    if (paintColorDdl !== null) {
        // get the index of the selected option 
        var paintColorIdx = paintColorDdl.selectedIndex;
        // get the value of the selected option 
        selectedPaintColor = paintColorDdl.options[paintColorIdx].value;
    }

    var tableTopColorDdl = document.getElementById('selectedTableTopColorOption');
    var selectedTableTopColor;

    if (tableTopColorDdl !== null) {
        // get the index of the selected option 
        var tableTopColorIdx = tableTopColorDdl.selectedIndex;
        // get the value of the selected option 
        selectedTableTopColor = tableTopColorDdl.options[tableTopColorIdx].value;
    }

    var backrestDdl = document.getElementById('selectedBackrestTypeOption');
    var selectedBackrest;

    if (backrestDdl !== null) {
        // get the index of the selected option 
        var backrestIdx = backrestDdl.selectedIndex;
        // get the value of the selected option 
        selectedBackrest = backrestDdl.options[backrestIdx].value;
    }

    var colorBackrestDdl = document.getElementById('selectedColorBackrestOption');
    var selectedColorBackrest;

    if (colorBackrestDdl !== null) {
        // get the index of the selected option 
        var colorBackrestIdx = colorBackrestDdl.selectedIndex;
        // get the value of the selected option 
        selectedColorBackrest = colorBackrestDdl.options[colorBackrestIdx].value;
    }

    var colorArmrestDdl = document.getElementById('selectedColorArmrestOption');
    var selectedColorArmrest;

    if (colorArmrestDdl !== null) {
        // get the index of the selected option 
        var colorArmrestIdx = colorArmrestDdl.selectedIndex;
        // get the value of the selected option 
        selectedColorArmrest = colorArmrestDdl.options[colorArmrestIdx].value;
    }

    var colorSeatingDdl = document.getElementById('selectedColorSeatingOption');
    var selectedColorSeating;

    if (colorSeatingDdl !== null) {
        // get the index of the selected option 
        var colorSeatingIdx = colorSeatingDdl.selectedIndex;
        // get the value of the selected option 
        selectedColorSeating = colorSeatingDdl.options[colorSeatingIdx].value;
    }

    var armrestDdl = document.getElementById('selectedArmrestOption');
    var selectedArmrest;

    if (armrestDdl !== null) {
        // get the index of the selected option 
        var armrestIdx = armrestDdl.selectedIndex;
        // get the value of the selected option 
        selectedArmrest = armrestDdl.options[armrestIdx].value;
    }

    var stackableDdl = document.getElementById('selectedStackableOption');
    var selectedStackable;

    if (stackableDdl !== null) {
        // get the index of the selected option 
        var stackableIdx = stackableDdl.selectedIndex;
        // get the value of the selected option 
        selectedStackable = stackableDdl.options[stackableIdx].value;
    }

    var modelDdl = document.getElementById('selectedModelOption');
    var selectedModel;

    if (modelDdl !== null) {
        // get the index of the selected option 
        var modelIdx = modelDdl.selectedIndex;
        // get the value of the selected option 
        selectedModel = modelDdl.options[modelIdx].value;
    }

    var deskHeightDdl = document.getElementById('selectedDeskHeightOption');
    var selectedDeskHeight;

    if (deskHeightDdl !== null) {
        // get the index of the selected option 
        var deskHeightIdx = deskHeightDdl.selectedIndex;
        // get the value of the selected option 
        selectedDeskHeight = deskHeightDdl.options[deskHeightIdx].value;
    }

    var extraProductDdl = document.getElementById('selectedExtraProductOption');
    var selectedExtraProduct;

    if (extraProductDdl !== null) {
        // get the index of the selected option 
        var extraProductIdx = extraProductDdl.selectedIndex;
        // get the value of the selected option 
        selectedExtraProduct = extraProductDdl.options[extraProductIdx].value;
    }

    var dimensionsDdl = document.getElementById('selectedDimensionsOption');
    var selectedDimensions;

    if (dimensionsDdl !== null) {
        // get the index of the selected option 
        var dimensionsIdx = dimensionsDdl.selectedIndex;
        // get the value of the selected option 
        selectedDimensions = dimensionsDdl.options[dimensionsIdx].value;
    }

    var rentTimeDdl = document.getElementById('selectedRentPeriodInMinutesOption');
    var selectedTime;

    if (rentTimeDdl !== null) {
        // get the index of the selected option
        var timeIdx = rentTimeDdl.selectedIndex;
        // get the value of the selected option 
        selectedTime = rentTimeDdl.options[timeIdx].value;
    }

    fetch(action, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            blockId,
            code,
            language,
            selectedFootCross,
            selectedPaintColor,
            selectedColorLegs,
            selectedTableTopColor,
            selectedBackrestType: selectedBackrest,
            selectedDimensions,
            selectedColorBackrest,
            selectedColorArmrest,
            selectedColorSeating,
            selectedArmrest,
            selectedStackable,
            selectedModel,
            selectedDeskHeight,
            selectedExtraProduct,
            selectedTime
        })
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            BindResult(html);
        })
        .catch(function (err) {
            console.log(err);
        });
}

initProductConfigurator();